export default __webpack_public_path__ + "static/media/angry-emoji.df243135.svg";